import styled from "styled-components";

export const Wrapper = styled.div(({ theme }) => ({
  ...theme.paddings(30, 0, 50, 0),
  backgroundColor: "#f5f5f5",
  flexGrow: 1,
  minHeight: "calc(100vh - 200px)",

  [theme.down("sm")]: {
    ...theme.paddings(20, 0, 30, 0),
  },
}));

export const PageTitle = styled.h1(({ theme }) => ({
  fontSize: 32,
  fontWeight: 600,
  color: "#333",
  margin: 0,
  marginBottom: 8,

  [theme.down("sm")]: {
    fontSize: 24,
  },
}));

export const PageSubtitle = styled.p(({ theme }) => ({
  fontSize: 16,
  color: "#666",
  margin: 0,
  marginBottom: 24,

  [theme.down("sm")]: {
    fontSize: 14,
    marginBottom: 16,
  },
}));

export const TwoColumnLayout = styled.div(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr 320px",
  gap: 24,
  alignItems: "start",

  [theme.down("lg")]: {
    gridTemplateColumns: "1fr 280px",
    gap: 20,
  },

  [theme.down("md")]: {
    gridTemplateColumns: "1fr",
  },
}));

export const MainContent = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: 24,

  [theme.down("md")]: {
    gap: 20,
  },

  [theme.down("sm")]: {
    gap: 16,
  },
}));

export const Sidebar = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: 20,

  [theme.down("md")]: {
    gap: 16,
  },
}));

// Balance Card
export const BalanceCard = styled.div(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: 16,
  padding: "24px 28px",
  borderRadius: 12,
  background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
  color: "#fff",
  boxShadow: "0 4px 20px rgba(102, 126, 234, 0.35)",

  [theme.down("sm")]: {
    padding: "20px",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: 12,
  },
}));

export const BalanceCardIcon = styled.div(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 48,
  height: 48,
  borderRadius: 12,
  backgroundColor: "rgba(255, 255, 255, 0.2)",
  color: "#fff",

  [theme.down("sm")]: {
    width: 40,
    height: 40,
  },
}));

export const BalanceCardContent = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: 4,
}));

export const BalanceLabel = styled.div(({ theme }) => ({
  fontSize: 14,
  opacity: 0.9,
  fontWeight: 500,
}));

export const BalanceAmount = styled.div(({ theme }) => ({
  fontSize: 32,
  fontWeight: 700,
  letterSpacing: "-0.5px",

  [theme.down("sm")]: {
    fontSize: 28,
  },
}));

export const CreditLimitText = styled.div(({ theme }) => ({
  fontSize: 14,
  opacity: 0.8,
  marginTop: 4,
}));

// Content Card
export const ContentCard = styled.div(({ theme }) => ({
  backgroundColor: "#fff",
  borderRadius: 12,
  padding: 24,
  border: "1px solid #e5e5e5",
  boxShadow: "0 1px 3px rgba(0,0,0,0.08)",

  [theme.down("sm")]: {
    padding: 16,
    borderRadius: 8,
  },
}));

export const SectionTitle = styled.h3(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: 10,
  fontSize: 18,
  fontWeight: 600,
  color: "#333",
  margin: 0,
  marginBottom: 20,

  [theme.down("sm")]: {
    fontSize: 16,
    marginBottom: 16,
  },
}));

export const SectionIcon = styled.span(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  color: "#666",
}));

// Payment Methods
export const PaymentMethodsGrid = styled.div(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  gap: 16,

  [theme.down("sm")]: {
    gap: 12,
  },

  [theme.down("xs")]: {
    gridTemplateColumns: "repeat(2, 1fr)",
  },
}));

export const PaymentMethodCard = styled.div(({ theme, $isActive }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: 12,
  padding: "20px 16px",
  borderRadius: 12,
  border: `2px solid ${$isActive ? "#01A0D4" : "#e5e5e5"}`,
  backgroundColor: $isActive ? "rgba(1, 160, 212, 0.05)" : "#fff",
  cursor: "pointer",
  transition: "all 0.2s ease",

  "&:hover": {
    borderColor: $isActive ? "#01A0D4" : "#c0c0c0",
    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
  },

  [theme.down("sm")]: {
    padding: "16px 12px",
    gap: 8,
  },
}));

export const PaymentMethodLogo = styled.img(({ theme }) => ({
  maxWidth: 120,
  maxHeight: 60,
  objectFit: "contain",

  [theme.down("sm")]: {
    maxWidth: 100,
    maxHeight: 50,
  },
}));

export const PaymentMethodName = styled.span(({ theme }) => ({
  fontSize: 14,
  fontWeight: 500,
  color: "#333",
  textAlign: "center",
}));

// Amount Input
export const AmountInputWrapper = styled.div(({ theme }) => ({
  position: "relative",
  marginBottom: 8,
}));

export const AmountInput = styled.input(({ theme, $hasError }) => ({
  width: "100%",
  padding: "16px 60px 16px 16px",
  fontSize: 18,
  fontWeight: 500,
  color: "#333",
  border: `1px solid ${$hasError ? "#ef4444" : "#d0d0d0"}`,
  borderRadius: 8,
  outline: "none",
  transition: "all 0.2s ease",
  boxSizing: "border-box",

  "&:focus": {
    borderColor: $hasError ? "#ef4444" : "#01A0D4",
    boxShadow: `0 0 0 3px ${$hasError ? "rgba(239, 68, 68, 0.1)" : "rgba(1, 160, 212, 0.1)"}`,
  },

  "&::placeholder": {
    color: "#999",
    fontWeight: 400,
  },

  "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
    WebkitAppearance: "none",
    margin: 0,
  },

  [theme.down("sm")]: {
    padding: "14px 50px 14px 14px",
    fontSize: 16,
  },
}));

export const AmountSuffix = styled.span(({ theme }) => ({
  position: "absolute",
  right: 16,
  top: "50%",
  transform: "translateY(-50%)",
  fontSize: 16,
  fontWeight: 500,
  color: "#666",

  [theme.down("sm")]: {
    right: 14,
    fontSize: 14,
  },
}));

export const ErrorText = styled.div(({ theme }) => ({
  fontSize: 13,
  color: "#ef4444",
  marginBottom: 12,
}));

// Quick Amounts
export const QuickAmountsLabel = styled.div(({ theme }) => ({
  fontSize: 14,
  color: "#666",
  marginBottom: 12,
  marginTop: 16,
}));

export const QuickAmountsGrid = styled.div(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  gap: 10,
  marginBottom: 24,

  [theme.down("sm")]: {
    gap: 8,
    marginBottom: 20,
  },

  [theme.down("xs")]: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: 8,
  },
}));

export const QuickAmountButton = styled.button(({ theme, $isActive }) => ({
  padding: "10px 16px",
  fontSize: 14,
  fontWeight: 500,
  color: $isActive ? "#fff" : "#333",
  backgroundColor: $isActive ? "#01A0D4" : "#f5f5f5",
  border: `1px solid ${$isActive ? "#01A0D4" : "#e0e0e0"}`,
  borderRadius: 8,
  cursor: "pointer",
  transition: "all 0.2s ease",

  "&:hover": {
    backgroundColor: $isActive ? "#0190c0" : "#e8e8e8",
    borderColor: $isActive ? "#0190c0" : "#d0d0d0",
  },

  [theme.down("sm")]: {
    padding: "8px 12px",
    fontSize: 13,
  },

  [theme.down("xs")]: {
    padding: "10px 8px",
    fontSize: 13,
    width: "100%",
  },
}));

// Submit Button
export const SubmitButton = styled.button(({ theme }) => ({
  width: "100%",
  padding: "16px 24px",
  fontSize: 18,
  fontWeight: 600,
  color: "#fff",
  background: "linear-gradient(135deg, #667eea 0%, #5ac8d8 100%)",
  border: "none",
  borderRadius: 8,
  cursor: "pointer",
  transition: "all 0.2s ease",
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 10,

  "&:hover:not(:disabled)": {
    background: "linear-gradient(135deg, #5a71d4 0%, #4eb8c8 100%)",
    transform: "translateY(-1px)",
    boxShadow: "0 4px 12px rgba(102, 126, 234, 0.4)",
  },

  "&:active:not(:disabled)": {
    transform: "translateY(0)",
  },

  "&:disabled": {
    background: "#ccc",
    cursor: "not-allowed",
  },

  [theme.down("sm")]: {
    padding: "14px 20px",
    fontSize: 16,
    gap: 8,
  },
}));

export const LoadingWrapper = styled.div(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  minHeight: 24,
}));

// Info Card
export const InfoCard = styled.div(({ theme }) => ({
  backgroundColor: "#fff",
  borderRadius: 12,
  padding: 20,
  border: "1px solid #e5e5e5",
  boxShadow: "0 1px 3px rgba(0,0,0,0.08)",

  [theme.down("sm")]: {
    padding: 16,
    borderRadius: 8,
  },
}));

export const InfoCardTitle = styled.h4(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: 8,
  fontSize: 16,
  fontWeight: 600,
  color: "#333",
  margin: 0,
  marginBottom: 16,
}));

export const InfoCardIcon = styled.span(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  color: "#01A0D4",
}));

export const InfoList = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: 10,
}));

export const InfoItem = styled.div(({ theme }) => ({
  fontSize: 14,
  color: "#01A0D4",
  lineHeight: 1.5,
}));

// Recent Recharges
export const RecentRechargesCard = styled.div(({ theme }) => ({
  backgroundColor: "#fff",
  borderRadius: 12,
  padding: 20,
  border: "1px solid #e5e5e5",
  boxShadow: "0 1px 3px rgba(0,0,0,0.08)",

  [theme.down("sm")]: {
    padding: 16,
    borderRadius: 8,
  },
}));

export const RecentRechargesTitle = styled.h4(({ theme }) => ({
  fontSize: 16,
  fontWeight: 600,
  color: "#333",
  margin: 0,
  marginBottom: 16,
}));

export const RechargeItem = styled.div(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "12px 0",
  borderBottom: "1px solid #f0f0f0",

  "&:last-child": {
    borderBottom: "none",
    paddingBottom: 0,
  },

  "&:first-of-type": {
    paddingTop: 0,
  },
}));

export const RechargeAmount = styled.div(({ theme }) => ({
  fontSize: 15,
  fontWeight: 600,
  color: "#333",
  marginBottom: 2,
}));

export const RechargeDate = styled.div(({ theme }) => ({
  fontSize: 13,
  color: "#666",
}));

export const RechargeStatus = styled.div(({ theme, $success }) => ({
  display: "flex",
  alignItems: "center",
  gap: 4,
  fontSize: 13,
  fontWeight: 500,
  color: $success ? "#10b981" : "#666",
}));

// Legacy exports for compatibility
export const Title = styled.h2(({ theme }) => ({
  marginBottom: 20,
  color: "#151515",
}));

export const Content = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: 15,
}));

export const Header = styled.div(({ theme }) => ({
  paddingBottom: 15,
  color: "#4a4a4a",
  borderBottom: "1px solid #cecece",
}));

export const CurrentBalance = styled.div(({ theme }) => ({
  fontSize: 20,
}));

export const Body = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: 15,
}));

export const Subtitle = styled.h4(({ theme }) => ({
  color: "#4a4a4a",
}));

export const PaymentMethodCheckboxBlock = styled("div")(({ theme }) => ({
  position: "absolute",
  right: 5,
  top: 5,
}));

export const PaymentMethodDescription = styled("div")(({ theme, $isActive }) => ({
  fontSize: 14,
  fontWeight: 600,
  color: $isActive ? "#151515" : "#9e9e9e",
}));

export const InputBlock = styled.div(({ theme }) => ({}));

export const Button = styled("button")(({ theme }) => ({
  padding: "0 15px",
  position: "relative",
  border: "none",
  backgroundColor: theme.palette.searchButtonBg,
  cursor: "pointer",
  height: 46,
  fontSize: 20,
  color: theme.palette.white,
  borderRadius: 4,
}));

export const PaymentMethodsBlock = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(4, 1fr)",
  gap: 5,
}));

export const PaymentMethodItem = styled("div")(({ theme, $isActive }) => ({
  display: "flex",
  flexDirection: "column",
  padding: 10,
  gap: 10,
  justifyContent: "center",
  alignItems: "center",
  position: "relative",
  border: `1px solid ${$isActive ? "#1D3557" : "#4a4a4a"}`,
  cursor: "pointer",
}));

// комиссия платёжной системы и итог к оплате под суммой пополнения
export const CommissionQuote = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: 6,
  marginTop: 16,
  padding: "12px 16px",
  borderRadius: 8,
  backgroundColor: "#f5f6f8",
  fontSize: 14,

  "& > div": {
    display: "flex",
    justifyContent: "space-between",
    gap: 12,
  },

  "& > div > span:last-child": {
    whiteSpace: "nowrap",
  },

  "& > div:first-of-type > span:last-child": {
    color: "#dc2626",
  },

  "& > div.total": {
    fontSize: 16,
    fontWeight: 700,
  },
});
